(()=>{
  if(window.__AQUAPHORIA_V4__) return;
  window.__AQUAPHORIA_V4__=true;

  const d=document;
  const root=d.documentElement;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const fine=matchMedia('(hover:hover) and (pointer:fine)');
  const mobile=matchMedia('(max-width: 780px)');
  const ease='cubic-bezier(.22,1,.36,1)';
  const nativeScroll=!!(window.CSS&&CSS.supports&&CSS.supports('animation-timeline: view()'));
  const crossView=!!d.startViewTransition || !!(window.CSS&&CSS.supports&&CSS.supports('view-transition-name: aq-product-demo'));

  const saveData=!!navigator.connection?.saveData;
  const memory=Number(navigator.deviceMemory||8);
  const cores=Number(navigator.hardwareConcurrency||8);
  const tier=reduced.matches||saveData||memory<=4||cores<=4||mobile.matches?1:(fine.matches&&memory>=8&&cores>=8?3:2);

  root.classList.add('aq-v4-motion','aq-v4-motion-enhanced',`aq-v4-motion-tier-${tier}`);
  if(nativeScroll) root.classList.add('aq-v4-native-scroll');
  if(crossView) root.classList.add('aq-v4-view-transitions');

  const motionCss=`
  @view-transition{navigation:auto}
  ::view-transition-old(aq-page),::view-transition-new(aq-page){animation-duration:.42s;animation-timing-function:${ease}}
  ::view-transition-old(root){animation:aq4PageOut .34s ease both}
  ::view-transition-new(root){animation:aq4PageIn .52s ${ease} both}
  @keyframes aq4PageOut{to{opacity:.7;filter:blur(2px)}}
  @keyframes aq4PageIn{from{opacity:.72;filter:blur(3px)}}

  html.aq-v4-motion-enhanced .aq-v4-hero__media{opacity:0;transform:scale(1.025);transition:opacity 1.15s ${ease},transform 1.8s ${ease}}
  html.aq-v4-motion-enhanced.aq-v4-ready .aq-v4-hero__media{opacity:1;transform:scale(1)}
  html.aq-v4-motion-enhanced .aq-v4-hero__veil:after{content:'';position:absolute;inset:-18%;pointer-events:none;opacity:.45;mix-blend-mode:screen;background:radial-gradient(ellipse at 18% 12%,rgba(139,244,233,.16),transparent 34%),radial-gradient(ellipse at 82% 24%,rgba(83,182,202,.12),transparent 38%),repeating-linear-gradient(112deg,transparent 0 84px,rgba(185,255,247,.035) 92px 98px,transparent 108px 162px);filter:blur(3px);transform:translate3d(-2%,-1%,0) rotate(-2deg);animation:aq4LightDrift 13s ease-in-out infinite alternate}
  @keyframes aq4LightDrift{to{transform:translate3d(3%,2%,0) rotate(1.5deg) scale(1.035);opacity:.68}}
  html.aq-v4-motion-tier-1 .aq-v4-hero__veil:after{opacity:.22;filter:none;animation-duration:20s}
  html.aq-v4-motion-tier-1 .aq-v4-hero__caustic{opacity:.11;animation-duration:24s}

  html.aq-v4-motion-enhanced .aq-v4-specimen{will-change:transform,opacity;opacity:0;translate:0 28px;transition:opacity .9s ${ease} .28s,translate 1.05s ${ease} .28s}
  html.aq-v4-motion-enhanced.aq-v4-ready .aq-v4-specimen{opacity:1;translate:0 var(--aq4-specimen-y,0px)}
  html.aq-v4-motion-enhanced [data-aq-v4-row].aq-v4-enter,html.aq-v4-motion-enhanced [data-aq-v4-card].aq-v4-enter,html.aq-v4-motion-enhanced .aq-v4-provenance__line.aq-v4-enter{opacity:0;transform:translate3d(0,22px,0);transition:opacity .72s ${ease},transform .82s ${ease},background .35s ease}
  html.aq-v4-motion-enhanced [data-aq-v4-row].aq-v4-enter.is-visible,html.aq-v4-motion-enhanced [data-aq-v4-card].aq-v4-enter.is-visible,html.aq-v4-motion-enhanced .aq-v4-provenance__line.aq-v4-enter.is-visible{opacity:1;transform:none}
  html.aq-v4-motion-enhanced .aq-v4-index__row strong,html.aq-v4-motion-enhanced .aq-v4-world__title,html.aq-v4-motion-enhanced .aq-v4-index__row b,html.aq-v4-motion-enhanced .aq-v4-world__arrow{transition:transform .55s ${ease}}

  @media(hover:hover) and (pointer:fine){
    html.aq-v4-motion-enhanced .aq-v4-index__row:hover strong{transform:translateX(10px)}
    html.aq-v4-motion-enhanced .aq-v4-index__row:hover b{transform:translate(4px,-4px) rotate(5deg)}
    html.aq-v4-motion-enhanced .aq-v4-world:hover .aq-v4-world__title{transform:translateX(12px)}
    html.aq-v4-motion-enhanced .aq-v4-world:hover .aq-v4-world__arrow{transform:translate(5px,-5px) rotate(6deg)}
    html.aq-v4-motion-enhanced .aq-v4-exhibit__media:after{content:'';position:absolute;inset:0;pointer-events:none;background:linear-gradient(125deg,transparent 30%,rgba(255,255,255,.13) 48%,transparent 66%);transform:translateX(-120%);transition:transform .9s ${ease}}
    html.aq-v4-motion-enhanced .aq-v4-exhibit:hover .aq-v4-exhibit__media:after{transform:translateX(120%)}
  }

  html.aq-v4-motion-enhanced .aq-v4-hero__caustic{translate:var(--aq4-caustic-x,0px) var(--aq4-caustic-y,0px)}
  html.aq-v4-motion-enhanced .aq-v4-aquapedia__mark{translate:0 var(--aq4-aqua-y,0px);will-change:translate}

  @supports (animation-timeline:view()){
    html.aq-v4-native-scroll [data-aq-v4-row],html.aq-v4-native-scroll [data-aq-v4-card],html.aq-v4-native-scroll .aq-v4-provenance__line{opacity:0;transform:translate3d(0,26px,0) scale(.992);animation:aq4NativeReveal 1ms linear both;animation-timeline:view();animation-range:entry 4% cover 30%}
    @keyframes aq4NativeReveal{to{opacity:1;transform:none}}
    html.aq-v4-native-scroll .aq-v4-progress{transform:scaleX(0);animation:aq4NativeProgress 1ms linear both;animation-timeline:scroll(root block)}
    @keyframes aq4NativeProgress{to{transform:scaleX(1)}}
    html.aq-v4-native-scroll .aq-v4-hero__image{animation:aq4HeroDepth 1ms linear both;animation-timeline:scroll(root block);animation-range:0 100vh}
    @keyframes aq4HeroDepth{from{transform:translate3d(0,0,0) scale(1.035)}to{transform:translate3d(0,34px,0) scale(1.055)}}
    html.aq-v4-native-scroll .aq-v4-specimen{animation:aq4SpecimenDepth 1ms linear both;animation-timeline:scroll(root block);animation-range:0 90vh}
    @keyframes aq4SpecimenDepth{from{translate:0 0}to{translate:0 28px}}
    html.aq-v4-native-scroll .aq-v4-aquapedia__mark{animation:aq4AquaDepth 1ms linear both;animation-timeline:view();animation-range:entry 0% exit 100%}
    @keyframes aq4AquaDepth{from{translate:0 -24px}to{translate:0 24px}}
  }

  html.aq-v4-motion-enhanced .cart-drawer__dialog,html.aq-v4-motion-enhanced .cart-drawer__inner{transition:transform .52s ${ease},opacity .38s ease}
  html.aq-v4-motion-enhanced .aq-v4-cart-ripple{position:fixed;z-index:9999;width:12px;height:12px;border-radius:50%;border:1px solid rgba(118,216,209,.82);pointer-events:none;transform:translate(-50%,-50%) scale(.4);opacity:.95;animation:aq4CartRipple .72s ${ease} forwards}
  @keyframes aq4CartRipple{to{transform:translate(-50%,-50%) scale(6);opacity:0}}

  @media(max-width:780px){
    html.aq-v4-motion-enhanced [data-aq-v4-row].aq-v4-enter,html.aq-v4-motion-enhanced [data-aq-v4-card].aq-v4-enter,html.aq-v4-motion-enhanced .aq-v4-provenance__line.aq-v4-enter{transform:translate3d(0,14px,0)}
    html.aq-v4-motion-enhanced .aq-v4-hero__media{transform:scale(1.012)}
    html.aq-v4-motion-enhanced .aq-v4-hero__veil:after{opacity:.28;filter:none}
  }
  @media(prefers-reduced-motion:reduce){
    @view-transition{navigation:none}
    html.aq-v4-motion-enhanced .aq-v4-hero__media,html.aq-v4-motion-enhanced .aq-v4-specimen,html.aq-v4-motion-enhanced .aq-v4-enter{opacity:1!important;transform:none!important;translate:none!important;transition:none!important;animation:none!important}
    html.aq-v4-motion-enhanced .aq-v4-hero__veil:after{animation:none!important;opacity:.16!important}
  }
  `;
  const style=d.createElement('style');
  style.id='aq-v4-motion-enhanced-style';
  style.textContent=motionCss;
  d.head.appendChild(style);

  const isHome=()=>!!d.querySelector('[data-aq-v4-home]');
  let loaderFinished=false;
  function finishLoader(){
    if(loaderFinished)return;
    loaderFinished=true;
    const el=d.querySelector('[data-aq-v4-loader]');
    if(!el)return;
    root.classList.add('aq-v4-loader-done');
    setTimeout(()=>el.remove(),700);
  }
  function setupLoader(){
    const el=d.querySelector('[data-aq-v4-loader]');
    if(!el)return;
    if(d.readyState==='complete')requestAnimationFrame(finishLoader);
    else addEventListener('load',finishLoader,{once:true});
    setTimeout(finishLoader,2800);
  }

  function tagPage(){
    d.body?.classList.toggle('aq-v4-homepage',isHome());
    d.body?.classList.toggle('aq-v4-scrolled',scrollY>36);
  }

  function productHandleFromUrl(value){
    try{
      const u=new URL(value,location.href);
      const m=u.pathname.match(/\/products\/([^/?#]+)/);
      return m?decodeURIComponent(m[1]).replace(/[^a-z0-9_-]/gi,'-').toLowerCase():'';
    }catch{return ''}
  }

  function wireProductTransitions(scope=d){
    if(reduced.matches||!crossView)return;
    const current=productHandleFromUrl(location.href);
    if(current){
      const target=scope.querySelector?.('main[data-template="product"] .product-media img,main[data-template="product"] .product-media-container img,main[data-template="product"] .product-information__media img');
      if(target) target.style.viewTransitionName=`aq-product-${current}`;
    }
    scope.querySelectorAll?.('a[href*="/products/"]').forEach(link=>{
      if(link.dataset.aq4ViewTransition)return;
      link.dataset.aq4ViewTransition='1';
      link.addEventListener('pointerdown',()=>{
        const handle=productHandleFromUrl(link.href);
        if(!handle)return;
        d.querySelectorAll('[style*="view-transition-name"]').forEach(el=>{if(el!==link)el.style.removeProperty('view-transition-name')});
        const card=link.closest('product-card,.aq-v4-exhibit,.aq-v4-specimen,.aq-fulfillment-v3__product')||link.parentElement;
        const image=card?.querySelector?.('img')||link.querySelector?.('img');
        if(image) image.style.viewTransitionName=`aq-product-${handle}`;
      },{passive:true});
    });
  }

  let revealIO,itemIO;
  function reveals(scope=d){
    const nodes=scope.querySelectorAll?.('[data-aq-v4-reveal-group]')||[];
    if(reduced.matches){nodes.forEach(n=>n.classList.add('is-visible'));return}
    revealIO ||= new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');revealIO.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    nodes.forEach(n=>{if(!n.dataset.aq4Observed){n.dataset.aq4Observed='1';revealIO.observe(n)}});
  }

  function itemReveals(scope=d){
    const nodes=scope.querySelectorAll?.('[data-aq-v4-row],[data-aq-v4-card],.aq-v4-provenance__line')||[];
    if(nativeScroll||reduced.matches){nodes.forEach(n=>n.classList.add('is-visible'));return}
    itemIO ||= new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){const el=e.target,delay=Math.min(240,Number(el.dataset.aq4Delay||0));setTimeout(()=>el.classList.add('is-visible'),delay);itemIO.unobserve(el)}}),{threshold:.08,rootMargin:'0px 0px -5% 0px'});
    nodes.forEach((n,i)=>{if(n.dataset.aq4ItemObserved)return;n.dataset.aq4ItemObserved='1';n.dataset.aq4Delay=String((i%5)*55);n.classList.add('aq-v4-enter');itemIO.observe(n)});
  }

  function depth(scope=d){
    if(reduced.matches||!fine.matches||tier===1)return;
    scope.querySelectorAll?.('[data-aq-v4-depth]').forEach(el=>{
      if(el.dataset.aq4Depth)return;
      el.dataset.aq4Depth='1';
      let raf=0;
      el.addEventListener('pointermove',e=>{
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(()=>{
          const b=el.getBoundingClientRect();
          if(!b.width||!b.height)return;
          const x=(e.clientX-b.left)/b.width-.5,y=(e.clientY-b.top)/b.height-.5;
          el.style.setProperty('--aq4-ry',`${(x*(tier===3?3.2:2.2)).toFixed(2)}deg`);
          el.style.setProperty('--aq4-rx',`${(-y*(tier===3?2.4:1.6)).toFixed(2)}deg`);
        });
      },{passive:true});
      el.addEventListener('pointerleave',()=>{el.style.setProperty('--aq4-rx','0deg');el.style.setProperty('--aq4-ry','0deg')},{passive:true});
    });
  }

  function progress(){
    if(reduced.matches||d.querySelector('.aq-v4-progress'))return;
    const p=d.createElement('div');
    p.className='aq-v4-progress';
    p.setAttribute('aria-hidden','true');
    d.body.appendChild(p);
  }

  let scrollRaf=0;
  function onScroll(){
    if(scrollRaf)return;
    scrollRaf=requestAnimationFrame(()=>{
      scrollRaf=0;
      tagPage();
      if(reduced.matches||nativeScroll)return;
      const max=Math.max(1,d.documentElement.scrollHeight-innerHeight),progressValue=Math.max(0,Math.min(1,scrollY/max));
      root.style.setProperty('--aq4-scroll',progressValue.toFixed(4));
      const hero=d.querySelector('.aq-v4-hero__image');
      if(hero){const amp=innerWidth>780?36:10,y=Math.min(amp,scrollY*(innerWidth>780?.032:.012));hero.style.transform=`translate3d(0,${y.toFixed(1)}px,0) scale(${innerWidth>780?'1.045':'1.018'})`}
      if(innerWidth>780&&tier>1){
        root.style.setProperty('--aq4-specimen-y',`${Math.min(32,scrollY*.026).toFixed(1)}px`);
        root.style.setProperty('--aq4-caustic-x',`${Math.min(20,scrollY*.012).toFixed(1)}px`);
        root.style.setProperty('--aq4-caustic-y',`${Math.min(18,scrollY*.018).toFixed(1)}px`);
        const aqua=d.querySelector('.aq-v4-aquapedia');
        if(aqua){const r=aqua.getBoundingClientRect(),v=Math.max(-28,Math.min(28,(innerHeight*.5-r.top)*.025));root.style.setProperty('--aq4-aqua-y',`${v.toFixed(1)}px`)}
      }
    });
  }

  function cartRipple(btn){
    if(reduced.matches)return;
    const b=btn.getBoundingClientRect();
    const ripple=d.createElement('i');
    ripple.className='aq-v4-cart-ripple';
    ripple.setAttribute('aria-hidden','true');
    ripple.style.left=`${b.left+b.width/2}px`;
    ripple.style.top=`${b.top+b.height/2}px`;
    d.body.appendChild(ripple);
    ripple.addEventListener('animationend',()=>ripple.remove(),{once:true});
  }

  function purchaseFeedback(){
    d.addEventListener('pointerdown',e=>{
      const btn=e.target.closest?.('.add-to-cart-button,.quick-add__button,.shopify-payment-button__button,.cart-drawer .checkout-button,.aq-v4-button');
      if(!btn||reduced.matches)return;
      btn.animate([{transform:'scale(1)'},{transform:'scale(.982)'},{transform:'scale(1)'}],{duration:300,easing:ease});
      if(btn.matches('.add-to-cart-button,.quick-add__button')) cartRipple(btn);
    },{passive:true});
  }

  function enhance(scope=d){reveals(scope);itemReveals(scope);depth(scope);wireProductTransitions(scope)}
  function ready(){requestAnimationFrame(()=>requestAnimationFrame(()=>root.classList.add('aq-v4-ready')))}
  function boot(){
    setupLoader();
    tagPage();
    progress();
    enhance(d);
    onScroll();
    addEventListener('scroll',onScroll,{passive:true});
    addEventListener('resize',onScroll,{passive:true});
    purchaseFeedback();
    ready();
  }

  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  d.addEventListener('shopify:section:load',e=>{tagPage();enhance(e.target);ready()});
  reduced.addEventListener?.('change',()=>{
    if(reduced.matches){
      root.classList.add('aq-v4-ready');
      d.querySelectorAll('[data-aq-v4-reveal-group],.aq-v4-enter').forEach(n=>n.classList.add('is-visible'));
      d.querySelectorAll('[data-aq-v4-depth]').forEach(n=>{n.style.removeProperty('--aq4-rx');n.style.removeProperty('--aq4-ry')});
    }
  });
})();
